<template>
	<vs-dialog v-model="active" class="domicializar">
      <template #header>
      <h4 class="not-margin">
          Restablecer Cargos
      </h4>
      </template>
      <div class="con-form">
          <div style="max-width: 100%">
              <vs-table>
                  <template #thead>
                  <vs-tr>
                      <vs-th>
                          Nombre
                      </vs-th>
                      <vs-th>
                          Matrícula
                      </vs-th>
                      <vs-th>
                          Programa
                      </vs-th>
                  </vs-tr>
                  </template>
                  <template #tbody>
                  <vs-tr
                      :key="i"
                      v-for="(tr, i) in selected"
                      :data="tr"
                      style="vertical-align: top;"
                  >
                      <vs-td>
                              <strong>{{ tr.nombre }}</strong>
                      </vs-td>
                      <vs-td>
                          <md-content class="cienCincuenta">
                              <strong>{{ tr.matricula }}</strong>
                          </md-content>
                      </vs-td>
                      <vs-td>
                          <md-content class="cienCincuenta">
                            <vs-select class="aqui pt-0" placeholder="Seleccione un programa" :key="programaId" v-model="programa[i]" :disabled="!programas.length" autocomplete="off">
                                <template v-if="programas.length" autocomplete="off">
                                    <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                          </md-content>
                      </vs-td>
                  </vs-tr>
                  </template>
              </vs-table>
          </div>
      </div>

      <template #footer>
      <div class="footer-dialog d-flex">
          <vs-button block danger>
            Cancelar
          </vs-button>
          <vs-button
            @click="getRestablecer()"
            block
            success>
            Restablecer Cargos
          </vs-button>
      </div>
      </template>
  </vs-dialog>
</template>

<script>
import reportes from '../../../../api/requests/reportes'
export default {
	props:[
	  'value',
    'selected',
    'institucion',
    'cicloEscolar'
  ],
  data () {
      return {
          active: false,
          programa: [],
          programas: [
            {
              id: "1",
              text: "programa1"
            },
            {
              id: "2",
              text: "programa2"
            }
          ],
          programaId: (new Date()).getTime(),
      }
  },
  methods: {
    async getProgramas () {
      if (this.institucion && this.cicloEscolar){
          let alumno = []
          this.selected.forEach(i => {
            var obj = {
                institucion: this.institucion,
                id: atob(i.estadoCuenta),
                ciclo_escolar: this.cicloEscolar,
            }
            alumno.push(obj)
          })
          // let alumnos = {alumnos: alumno}
          const alumnos = new URLSearchParams();
          let j = 0
          alumno.forEach(i =>{
            alumnos.append('alumnos[' + j + '][institucion]', i.institucion)
            alumnos.append('alumnos[' + j + '][id]', i.id)
            alumnos.append('alumnos[' + j + '][ciclo_escolar]', i.ciclo_escolar)
            j++
          })
          console.log(alumnos)
          const response = await reportes.getProgramas(alumnos)
          console.log(response)
          const { opciones: programas, default:val } = response || {}
            if (programas){
                this.listPrograma = Object.values(programas)
                this.programa = val
                this.programaDefault = val
                this.programaId = (new Date()).getTime()
            }
      }
    },
    getSeleccionPrograma(){
      if(this.rows != ''){
        let result = []
        this.selected.forEach(i => {
          result.push('')
        })
        this.programa = result
      }
    },
    async getRestablecer(){
      // const loading = this.$vs.loading()
      let restablecerSelect = []
      for(var x = 0;x < this.programa.length; x++){
          console.log(this.selected[x].id)
          var obj = {
            id : this.personaId,
            ciclo_escolar: this.cicloEscolar,
            institucion: this.institucion,
          }
          programasSelect.push(obj)
      }
      let restablcer = restablecerSelect
      console.log(restablcer)
          // var obj = {
          //   id : this.personaId,
          //   ciclo_escolar: this.cicloEscolar,
          //   institucion: this.institucion,
          //   programa: this.programa,
          //   cargo : this.seleccionDomiciliar[x].id,
          //   cuenta : this.infoCuenta[x].id
          // }
          // domiciliar.push(obj)
      let solicitudes = domiciliar
      return false
      try {
        let domiciliar = []
          for(var x = 0;x < this.seleccionDomiciliar.length; x++){
            if(this.typeCargo[x] === 'domiciliar'){
              var obj = {
                id : this.personaId,
                ciclo_escolar: this.cicloEscolar,
                institucion: this.institucion,
                programa: this.programa,
                cargo : this.seleccionDomiciliar[x].id,
                cuenta : this.infoCuenta[x].id
              }
              domiciliar.push(obj)
            }
          }
          let solicitudes = domiciliar
          const response = await domicializacion.getGuardarSeleccionada(solicitudes)
          
          this.$emit('refreshTable')
          loading.close()
          var xhr = new XMLHttpRequest();
          xhr.open('GET', `/api/v1/domiciliacion/solicitud/${response.data.data}/descargar`, true);
          xhr.responseType = 'blob';

          xhr.onload = function(e) {
          if (this.status == 200) {
              var blob = new Blob([this.response], {type: 'application/pdf'});
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = "Solicitud-Domiciliacion.pdf";
              link.click();       
          }
          };

          xhr.send();
          this.active = false
          loading.close()
          
      } catch (error) {
          loading.close()
          this.$vs.notification({
              progress: 'auto',
              color: 'danger',
              title: 'Algo salio mal',
              text: 'Por favor contacta al administrador'
          })
      }
    },
  },
  watch: {
    value (val) {
      this.active = val
      this.getProgramas()
      this.getSeleccionPrograma()
    },
  }
}
</script>
